var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"choose-number"},[_c('v-btn',{staticClass:"white--text",attrs:{"data-tf-popup":"eH7189he","data-tf-iframe-props":"title=Request Local Number","small":"","color":"primary","rounded":""}},[_vm._v(" Choose a New Number ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }